<template>
    <div >
      <div class="value mb-2">{{value}}</div>
      <div class="info ">
        <table>
          <tr>
            <td>
              <b>{{setA}}</b>
            </td>
            <td style="text-align: left;">
              {{Math.round(input/1000)}}
            </td>
          </tr>
          <tr>
            <td>
             <b> {{setB}}</b>
            </td>
            <td style="text-align: left;">
              {{Math.round(output/1000)}}
            </td>
          </tr>
        </table>
      </div>
      <slot  name="chart"></slot>
    </div>
</template>

<script>
    export default {
        name: "pie-chart-wrapper",
        props:{
          value:String,
          height:String,
          input:Number,
          output:Number,
          setA:String,
          setB:String
        },
        data:()=>({

        }),
        computed:{
          heightC(){
            return "height:"+this.height+";"
          }
        }
    }
</script>

<style scoped>
  .info{
    font-size: 80%;
    position: absolute;
    margin-left: 66px;
    top:118px;
    max-width: 75px;
    text-align: right;
  }
  .chart{
    padding: 0px;
    margin:0px;
  }
  .wrapper{

  }
  .value{
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/pie-chart-wrapper.vue